import { HourglassOutlined } from '@ant-design/icons'
import { Tooltip } from 'antd'
import PropTypes from 'prop-types'
import { createUseStyles } from 'react-jss'
import CircleCheckIcon from './CircleCheckIcon'

const PENDING_TITLE =
  'The signed PDF is still being generated, the signature will show up on the report shortly.'

const useStyles = createUseStyles({
  pendingIcon: {
    color: '#1890ff',
  },
})

// Three states: waiting for the signed PDF to be regenerated, signed, not
// signed. The last two fall through to the shared check/cross icon.
function SignedStatusIcon({ signed = false, pdfPending = false }) {
  const classes = useStyles()

  if (pdfPending) {
    return (
      <Tooltip title={PENDING_TITLE}>
        <HourglassOutlined className={classes.pendingIcon} />
      </Tooltip>
    )
  }

  return <CircleCheckIcon checked={signed} />
}

SignedStatusIcon.propTypes = {
  signed: PropTypes.bool,
  pdfPending: PropTypes.bool,
}

export default SignedStatusIcon
